import { booleanAttribute, Component, computed, input } from '@angular/core';
import { MuiColor } from '../../utility';


type IconBoxColor = MuiColor | `${MuiColor}` | string | null | undefined;

@Component({
  selector: 'mui-list-item-icon',
  template: `
    <ng-content select="i, mui-icon"></ng-content>`,
  styleUrl: './mui-list-item-icon.component.scss',
  host: {
    /* eslint-disable @typescript-eslint/naming-convention */
    '[class]': 'classes()'
    /* eslint-enable @typescript-eslint/naming-convention */
  }
})
export class MuiListItemIcon {

  readonly boxed = input(false, { transform: booleanAttribute });

  readonly color = input(null, {
    transform: (value: IconBoxColor): MuiColor | null => {
      return value ? <MuiColor>value : null;
    }
  });

  protected readonly classes = computed(() => {
    const classes = ['mui-list-item__icon'];

    if (this.boxed()) {
      classes.push('mui-list-item__icon--boxed');
    }
    if (this.color()) {
      classes.push(`mui-list-item__icon--${this.color()}`);
    }

    return classes.join(' ');
  });
}
